import { PinIcon } from "components/atoms/Icon";
import { Paragraph } from "components/atoms/Typography";
import { useBuildingModelHeaderQuery } from "queries/useBuildingModelHeaderQuery";
import { getDisplayInfo } from "utils/formatting";
import BuildingTags from "../BuildingTags";
import PropertyDropdown from "../PropertyDropdown";
import BuildingHeaderActions from "./BuildingHeaderActions";
import BuildingName from "./BuildingName";
import FundName from "./FundName";
import BuildingHeaderLoading from "./BuildingHeaderLoading";

interface BuildingPageHeaderProps {
    buildingModel: Building;
    selectedBMCRP: BuildingModelCarbonReductionPlan;
}

function BuildingPageHeader({ buildingModel, selectedBMCRP }: BuildingPageHeaderProps) {
    const { data: buildingModelHeader, isLoading } = useBuildingModelHeaderQuery(buildingModel.buildingModelUid);

    const addressComponents = [
        buildingModel.streetAddress,
        buildingModel.city,
        buildingModel.stateProvince,
        buildingModel.postalZipCode,
        buildingModel.country,
    ].filter((i) => i !== null);
    const fullAddress = addressComponents.join(", ");

    const { formatFunction } = getDisplayInfo("dataCoverage");

    // NOTE: These are currently mostly returning undefined. Assuming these will be added when more work is done on the backend, reverting to old logic for now
    // const dataCoverage: DataCoverage = {
    //     dataCoverage: buildingModel.modellingStatus as DataCoverageEnum,
    //     energyType: buildingModel.energyType as EnergyTypeEnum,
    //     energyTypeFromEquipmentData: buildingModel.energyTypeFromEquipmentData as EnergyTypeEnum,
    //     energyTypeFromUtilityData: buildingModel.energyTypeFromUtilityData as EnergyTypeEnum,
    //     equipmentDataHasSizeAndYear: buildingModel.equipmentDataHasSizeAndYear,
    //     equipmentDataUploaded: buildingModel.equipmentDataUploaded,
    //     modellingStatus: buildingModel.modellingStatus as ModellingStatus,
    //     utilityDataUploaded: buildingModel.utilityDataUploaded,
    // };

    if (isLoading || !buildingModelHeader) return <BuildingHeaderLoading />;

    const { dataCoverage } = buildingModelHeader;

    return (
        <div className="baseline-building-report-header">
            <div className="baseline-building-report-header--building-info">
                <div className="building-name-and-tags">
                    <BuildingName
                        buildingName={buildingModel.buildingName}
                        buildingModelUid={buildingModel.buildingModelUid}
                    />
                    {formatFunction(dataCoverage)}
                    <BuildingTags buildingModelUid={buildingModel.buildingModelUid} defaultTags={buildingModel.tags} />
                </div>
                <div className="building-header-property-and-location">
                    <PropertyDropdown
                        buildingModelUid={buildingModel.buildingModelUid}
                        propertyName={buildingModel.propertyName}
                    />
                    <FundName fundName={buildingModel.fundName} />
                    <Paragraph
                        style={{
                            color: "var(--audette-gray-500)",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <PinIcon />
                        <span style={{ marginLeft: "4px" }}>{fullAddress}</span>
                    </Paragraph>
                </div>
            </div>

            <BuildingHeaderActions buildingModel={buildingModel} selectedBMCRP={selectedBMCRP} />
        </div>
    );
}

export default BuildingPageHeader;
